// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OpenActivityTable from './components/open-activity-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    getOpenActivity
} from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

class OpenActivity extends Component {

    state = {
        results: null
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getOpenActivity( ).then( response => {

            this.setState( {
                results: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    render () {

        const {
            results
        } = this.state;
        const arrayResults = results !== null ? [...results] : [];
        const openActivityResults = arrayResults.map( i => (
            { ...i, unitName: this.props.unit.name } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header"> Open Activity </h2>
                </header>

                <main>
                    <section className="section-container">
                        { results !== [] ? (
                            <OpenActivityTable
                                results={openActivityResults}
                            />
                        ) :
                            'There are no records to display'
                        }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OpenActivity.displayName = 'OpenActivity';
OpenActivity.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( OpenActivity );
